import http from '@services/http';
import { SubmittedComment, FeedItemComment  } from 'types/comments';

export function saveComment(comment:SubmittedComment) {
  return http.post('/comments/comment', comment).then(c=> c as FeedItemComment);
}

export function deleteComment(commentId:number) {
  return http.delete(`/comments/delete?commentId=${commentId}`);
}